import { Component, OnInit } from '@angular/core';
import { MiscService } from 'src/app/_service/misc.service';
import { SharedService } from 'src/app/_service/shared.service';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LeadsService } from 'src/app/_service/leads.service';
declare var $: any;

@Component({
  selector: 'app-add-edit-pincode-machine-master',
  templateUrl: './add-edit-pincode-machine-master.component.html',
  styleUrls: ['./add-edit-pincode-machine-master.component.css']
})
export class AddEditPincodeMachineMasterComponent implements OnInit {
  placements = ['left'];
  popoverTitle = 'Are you sure?';
  popoverMessage = 'Are you really <b>sure</b> you want to do this?';
  confirmText = 'Yes <i class="fas fa-check"></i>';
  cancelText = 'No <i class="fas fa-times"></i>';
  confirmClicked = false;
  cancelClicked = false;
  daysList: any;
  zoneMachineForm: FormGroup; submitted: boolean = false; loading: boolean = false; circles: any; circles_copy: any;
  zones: any; zones_copy: any; allscanmachine: any; allscanmachine_copy: any; circlezones: any; ZoneName = []; CircleName = [];
  zone_macId: any = ''; disableSelect: any = []; diss_circle_city: boolean = false;
  diss_circle_zone: boolean = true; daterangeShow: boolean = false; openDayListbtn: boolean = false; allDays: any = []; underDateRangeDays: any = [];
  constructor(private leadapi: LeadsService, private activatedRoute: ActivatedRoute, public miscapi: MiscService, public sharedapi: SharedService, private formBuilder: FormBuilder, private router: Router) {
    this.zoneMachineForm = this.formBuilder.group({
      'circle_id': [null, Validators.required],
      'zone_id': [null, Validators.required],
      'machine_id': [null, Validators.required],
      'bookingDays': this.formBuilder.array([]),
      'from_date': [],
      'to_date': [],
      zoneMachineDateRange: this.formBuilder.group({
        'from_date': '',
        'to_date': ''
      }),
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['zoneMachine_id']) {
        this.zone_macId = params['zoneMachine_id'];
        this.patchZoneMachineData(this.zone_macId);
      }
    });

  }
  ngOnInit(): void {
    this.getcircle();
    this.getScanMachine();
  }

  get f() { return this.zoneMachineForm.controls; }

  async createZoneMachine() {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.zoneMachineForm.invalid) {
      this.loading = false;
      return;
    }
    this.zone_macId = this.activatedRoute.snapshot.paramMap.get('zoneMachine_id');
    this.zoneMachineForm.value.id = parseInt(this.zone_macId);
    await this.miscapi.saveZoneMachine(this.zoneMachineForm.value).subscribe((data: any) => {
      this.submitted = false;
      this.loading = false;
      if (data.status) {
        this.sharedapi.presentToast(data.msg);
        this.router.navigateByUrl('/zone-machine-master-list');
        this.zoneMachineForm.reset();
      }
      else {
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getcircle() {
    await this.leadapi.getcircles().subscribe((data: any) => {
      if (data.status) {
        this.circles = data.data;
        this.circles_copy = this.circles;
      } else {
        this.circles = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getCircleZone(circle_id) {
    let qString = 'circle=' + circle_id;
    await this.miscapi.getCircle_zone(qString).subscribe((data: any) => {
      if (data.status) {
        this.zones = data.data;
        this.zones_copy = this.zones;
      } else {
        this.zones = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });

  }

  async getScanMachine() {
    await this.miscapi.getallScanMachine().subscribe((data: any) => {
      if (data.status) {
        this.allscanmachine = data.data;
        this.allscanmachine_copy = this.allscanmachine;
      } else {
        this.allscanmachine = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  searchOnSelect(searchtText: any, type) {
    if (type == 'circle') {
      this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
    } else if (type == 'zones') {
      this.zones = this.sharedapi.searchData(searchtText, this.zones_copy, "zone_name");
    } else if (type == 'machine') {
      this.allscanmachine = this.sharedapi.searchData(searchtText, this.allscanmachine_copy, "name");
    }
  }

  setSearchValue(type) {
    if (type == 'circle') {
      $("#circleSearch").val('');
      $("#circleSearch").focus();
      this.circles = this.circles_copy;
    } else if (type == 'zone') {
      $("#zoneSearch").val('');
      $("#zoneSearch").focus();
      this.zones = this.zones_copy;
    } else if (type == 'machine') {
      $("#machineSearch").val('');
      $("#machineSearch").focus();
      this.allscanmachine = this.allscanmachine_copy;
    }
  }

  bookingDays(): FormArray {
    return this.zoneMachineForm.get("bookingDays") as FormArray
  }

  newQuantity(): FormGroup {
    return this.formBuilder.group({
      days_list: '',
      no_of_booking: '',
      from_time: '',
      to_time: ''
    })
  }

  addQuantity() {
    this.bookingDays().push(this.newQuantity());
    let getIndex = this.zoneMachineForm.controls["bookingDays"].value.length - 1;
    this.disableSelect[getIndex] = true;
  }

  removeQuantity(i: number) {
    this.bookingDays().removeAt(i);
    if (this.zoneMachineForm.value.bookingDays.length == 0) {
    }
  }

  async patchZoneMachineData(zone_macId) {
    await this.miscapi.getZoneMachineEditData(this.zone_macId).subscribe((response: any) => {
      if (response.status) {
        this.getCircleZone(response.data[0].circle_id);
        this.zoneMachineForm.patchValue({
          'circle_id': response.data[0].circle_id,
          'zone_id': response.data[0].zone_id,
          'machine_id': response.data[0].master_machine_id,
        });
        if (response.data[0].to_date) {
          this.daterangeShow = true;
          this.zoneMachineForm.patchValue({
            zoneMachineDateRange: {
              from_date: new Date(response.data[0].from_date),
              to_date: new Date(response.data[0].to_date)
            }
          });

          if (response.data[0].days) {
            let controlArray = this.zoneMachineForm.get('bookingDays') as FormArray;
            response.data.forEach((element, index) => {
              controlArray.push(this.formBuilder.group({
                days_list: element.days,
                no_of_booking: element.no_of_booking,
                from_time: element.from_time,
                to_time: element.to_time
              }));

            });
          }
          this.dateRangeChange(response.data[0].from_date, response.data[0].to_date);
        }

      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  openDateRange() {
    this.daterangeShow = true;
  }

  dateRangeChange(date1, date2) {
    const dateRangeDays = [];
    if (date2) {
      this.openDayListbtn = true;
      if (this.zoneMachineForm.value.bookingDays.length == 0) {
        this.addQuantity();
      }
    }
    this.zoneMachineForm.patchValue({
      'from_date': date1,
      'to_date': date2,
    });

    var from = new Date(date1);
    var to = new Date(date2);
    var DAYS = [
      { value: "Sun", name: "Sunday" },
      { value: "Mon", name: "Monday" },
      { value: "Tue", name: "Tuesday" },
      { value: "Wed", name: "Wednesday" },
      { value: "Thu", name: "Thursday" },
      { value: "Fri", name: "Friday" },
      { value: "Sat", name: "Saturday" }
    ]
    var d = from;
    while (d <= to) {
      this.allDays = DAYS[d.getDay()]
      d = new Date(d.getTime() + (24 * 60 * 60 * 1000));//👉️ Don't remove this code.
      dateRangeDays.push(this.allDays);
    }
    this.underDateRangeDays = new Set(dateRangeDays);
  }

}
